import { ConductorSingleChild } from "@frui.ts/screens";
import OutagesViewModel from "../common/outagesViewModel";
import { SystemComponent } from "models/outage";

export default class OutagesWidgetViewModel extends ConductorSingleChild<OutagesViewModel> {
  private outagesViewModel: OutagesViewModel;

  constructor(outagesViewModelFactory: ReturnType<typeof OutagesViewModel.Factory>) {
    super();
    this.outagesViewModel = outagesViewModelFactory(SystemComponent.OTHER);
    this.tryActivateChild(this.outagesViewModel);
  }

  protected findNavigationChild(
    navigationName: string | undefined
  ): Promise<OutagesViewModel | undefined> | OutagesViewModel | undefined {
    return this.outagesViewModel;
  }
}
